import { MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons";
import type { CSSProperties, ComponentProps, ComponentType } from "react";

import type { IconProps } from "../types";
import { FontAwesomeKitIcon } from "./FontAwesomeKitIcon";

export type IconSet =
  | {
      iconSet: "font-awesome";
      icon: ComponentProps<typeof FontAwesomeKitIcon>["name"];
      style?: ComponentProps<typeof FontAwesomeKitIcon>["style"];
      cssStyle?: CSSProperties;
    }
  | {
      iconSet: "material-community";
      icon: ComponentProps<typeof MaterialCommunityIcons>["name"];
      style?: never;
      cssStyle?: ComponentProps<typeof MaterialCommunityIcons>["style"];
    }
  | {
      iconSet: "material";
      icon: ComponentProps<typeof MaterialIcons>["name"];
      style?: never;
      cssStyle?: ComponentProps<typeof MaterialIcons>["style"];
    }
  | {
      iconSet: "custom";
      icon: ComponentType<IconProps & { style?: CSSProperties }>;
      style?: never;
      cssStyle?: CSSProperties;
    };

type IconComponentProps = IconSet & IconProps;

export const Icon = ({
  iconSet,
  icon,
  size = 24,
  color = "#000",
  style,
  cssStyle,
}: IconComponentProps) => {
  if (iconSet === "font-awesome") {
    return (
      <FontAwesomeKitIcon
        name={icon}
        size={size}
        color={color}
        style={style ?? "solid"}
        cssStyle={cssStyle}
      />
    );
  } else if (iconSet === "material") {
    return (
      <MaterialIcons name={icon} size={size} color={color} style={cssStyle} />
    );
  } else if (iconSet === "material-community") {
    return (
      <MaterialCommunityIcons
        name={icon}
        size={size}
        color={color}
        style={cssStyle}
      />
    );
  } else {
    const CustomIcon = icon;
    return <CustomIcon size={size} color={color} style={cssStyle} />;
  }
};
